const stickyBuyObservers = new WeakMap();

function bindStickyBuy(bar) {
  if (stickyBuyObservers.has(bar) || !('IntersectionObserver' in window)) return;

  const section = bar.closest('.shopify-section');
  const productForm = section?.querySelector('product-form-component[data-product-id], form[action*="/cart/add"]');
  const source = productForm?.closest('.buy-buttons-block') || productForm;
  if (!source) return;

  let sourcePassed = false;
  let footerReached = false;
  const update = () => {
    const visible = sourcePassed && !footerReached;
    bar.dataset.stuck = String(visible);
    bar.setAttribute('aria-hidden', String(!visible));
  };

  const sourceObserver = new IntersectionObserver(([entry]) => {
    sourcePassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
    update();
  });
  sourceObserver.observe(source);

  const footer = document.querySelector('footer') || document.querySelector('[class*="footer-group"]');
  const footerObserver = footer
    ? new IntersectionObserver(([entry]) => {
        footerReached = entry.isIntersecting;
        update();
      }, { rootMargin: '200px 0px 0px' })
    : null;
  footerObserver?.observe(footer);

  stickyBuyObservers.set(bar, { sourceObserver, footerObserver });
}

function initStickyBuy(root = document) {
  root.querySelectorAll?.('[data-wpx-sticky-buy]').forEach(bindStickyBuy);
}

function destroyStickyBuy(root) {
  root.querySelectorAll?.('[data-wpx-sticky-buy]').forEach((bar) => {
    const observers = stickyBuyObservers.get(bar);
    observers?.sourceObserver.disconnect();
    observers?.footerObserver?.disconnect();
    stickyBuyObservers.delete(bar);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initStickyBuy(), { once: true });
} else {
  initStickyBuy();
}

document.addEventListener('shopify:section:load', (event) => initStickyBuy(event.target));
document.addEventListener('shopify:section:unload', (event) => destroyStickyBuy(event.target));
